import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationsFacade } from '@kion/data-access/data-access-navigations';
import { Navigation } from '@kion/data-models';
import { CmsConfig } from '../../config/cms.config';

@Component({
  selector: 'kion-cms-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {

  burgerMenuOpened: boolean;
  navigationItems$: Observable<Navigation[]>;
  project: 'FS' | 'LR' | string;

  flyOutItemId: string;
  isInsideFlyOut: boolean;

  mobileFirstItem: any;
  mobileSecondItem: any;

  @ViewChild('burgerNavigation') burgerNavigation: ElementRef;

  constructor(private navigationsFacade: NavigationsFacade, private cmsConfig: CmsConfig) {
    this.project = this.cmsConfig.project;
  }

  ngOnInit(): void {
    this.burgerMenuOpened = false;
    this.navigationsFacade.loadAll('navigation');
    this.navigationItems$ = this.navigationsFacade.all$;
  }

  ngOnDestroy(): void {
    document.body.classList.remove('nav-open');
  }

  toggleBurgerMenu(): void {
    this.burgerMenuOpened = !this.burgerMenuOpened;
    if (this.burgerMenuOpened) {
      document.body.classList.add('nav-open');
      this.burgerNavigation.nativeElement.classList.add('open');
      return;
    }
    document.body.classList.remove('nav-open');
    this.burgerNavigation.nativeElement.classList.remove('open');
  }

  setItem(id: string) {
    setTimeout(() => {
      this.flyOutItemId = id;
    }, 100)
  }

  removeItem() {
    this.flyOutItemId = '';
    this.isInsideFlyOut = false;
  }

  isInside() {
   this.isInsideFlyOut = true;
  }

  removeItemAfterTime() {
    setTimeout(() => {
      if (!this.isInsideFlyOut) {
        this.flyOutItemId = '';
      }
    }, 100)
  }

  setFirstItem(item: any) {
    this.mobileFirstItem = item;
  }

  setSecondItem(item: any) {
    this.mobileSecondItem = item;
  }

  unsetFirstItem() {
    this.mobileFirstItem = null;
  }

  unsetSecondItem() {
    this.mobileSecondItem = null;
  }
}
